import { render } from "./landing-page.vue?vue&type=template&id=229fbeb9&scoped=true"
import script from "./landing-page.vue?vue&type=script&lang=js"
export * from "./landing-page.vue?vue&type=script&lang=js"

import "./landing-page.vue?vue&type=style&index=0&id=229fbeb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229fbeb9"]])

export default __exports__